import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import HeroSection from '../components/home/HeroSection';
import StatsSection from '../components/home/StatsSection';
import WhyChooseSection from '../components/home/WhyChooseSection';
import PropertiesSection from '../components/home/PropertiesSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ComplianceSecuritySection from '../components/home/ComplianceSecuritySection';
import CTASection from '../components/home/CTASection';
import AnimatedSection from '../components/ui/AnimatedSection';
import ScrollProgressBar from '../components/ui/ScrollProgressBar';
import { useScrollContext } from '../contexts/ScrollContext';
import SEO from '../components/SEO/SEO';

const HomePage = () => {
  const { setIsHomePage } = useScrollContext();

  useEffect(() => {
    setIsHomePage(true);
    return () => setIsHomePage(false);
  }, [setIsHomePage]);

  return (
    <>
      <SEO
        title="Global Property Investment"
        description="Invest in premium global real estate. Fractional property ownership, expert management, and transparent returns through our institutional platform."
        keywords="global real estate investment, property crowdfunding, fractional real estate, international real estate, property management"
        url="/"
        image="https://theblpartners.com/images/Hero_Image.png"
        imageAlt="BlueLagoon & Partners — premium global real estate"
      />
      <ScrollProgressBar />
      <Box as="main">
        <Box data-section="hero">
          <HeroSection />
        </Box>

        <Box data-section="stats">
          <StatsSection />
        </Box>

        <AnimatedSection delay={0}>
          <Box data-section="why-choose">
            <WhyChooseSection />
          </Box>
        </AnimatedSection>

        <AnimatedSection delay={80}>
          <Box data-section="properties">
            <PropertiesSection />
          </Box>
        </AnimatedSection>

        <AnimatedSection delay={120}>
          <Box data-section="how-it-works">
            <HowItWorksSection />
          </Box>
        </AnimatedSection>

        <AnimatedSection delay={160}>
          <Box data-section="testimonials">
            <TestimonialsSection />
          </Box>
        </AnimatedSection>

        <AnimatedSection delay={200}>
          <Box data-section="compliance">
            <ComplianceSecuritySection />
          </Box>
        </AnimatedSection>

        <AnimatedSection delay={240}>
          <Box data-section="cta">
            <CTASection />
          </Box>
        </AnimatedSection>
      </Box>
    </>
  );
};

export default HomePage;
